import { createStore, applyMiddleware, compose } from "redux"
import thunkMiddleware from "redux-thunk"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import rootReducer from "./reducers"

const persistConfig = {
  key: "v1",
  storage,
  blacklist: [
    "foods",
    "tokens",
    "categories",
    "combos",
    "order",
    "pinModal",
    "foodPageUiState",
    "warningPopup",
    "internetStatus",
    "deliveryInfo",
    "offlineOrders",
    "notViewedOrders",
    "orderForEditDetails",
    "foodPageSidebarRef",
    "printRequests",
    "groupedFoodIdsBasedOnCategory",
    "contractDeactivationStatus"
  ]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(
  persistedReducer,
  compose(
    applyMiddleware(thunkMiddleware)
  )
)

export const persistor = persistStore(store)